<template>
    <div class="first:border-t-0 border-t border-gray-275 dark:border-gray-625">
        <div ref="stuck-detector"></div>
        <details :open="isOpen">
            <summary
                ref="header"
                class="bg-gray-tier-3 list-none py-10 px-8 sticky top-0 z-10"
                :class="{
                    'transition duration-500 shadow-lg': isStuck,
                }"
            >
                <span class="flex font-medium items-center justify-between">
                    <span class="text-xl">{{ config.label }} <span class="text-scarlet" v-if="config.required">*</span></span>
                    <!--<span v-text="selectedOption?.attributes.label"></span>-->
                    <span aria-hidden="true" class="pb-options__toggle cursor-pointer flex items-center text-gray text-xs dark:text-gray-325">
                        {{ isOpen ? 'Hide options' : 'Show options' }}
                        <BaseSvg name="ExpandLessThick" class="transition-all size-5 dark:fill-gray" :class="{ 'rotate-180': isOpen }" aria-hidden="true" />
                    </span>
                </span>
            </summary>

            <div class="pb-12 pt-0.5 px-8">
                <ul class="grid gap-4" :class="{
                    'grid-cols-3': hasImages && config.options.length > 8,
                    'grid-cols-2': hasImages && config.options.length <= 8,
                    'grid-cols-1': !hasImages,
                }">
                    <ProductBuilderOption
                        v-for="option in config.options"
                        :name="name"
                        :option="option"
                        :value="config.value"
                        :sku="sku"
                        @select="handleSelect"
                        :validate="!config.suppress_validation"
                    />
                </ul>
            </div>
        </details>
    </div>
</template>
<script setup>
import { computed, onBeforeUnmount, onMounted, onUnmounted, ref, useTemplateRef, watch } from "vue";
import { useHelpers } from "@/Composables";
import { BaseSvg, ProductBuilderOption } from "@/Components";

const { slugify } = useHelpers()

const emit = defineEmits(['toggle', 'select']);
const { sku, open, config } = defineProps({
    sku: {
        type: String,
        required: true,
    },
    open: {
        type: Boolean,
        default: false,
        required: true,
    },
    config: {
        type: Object,
        required: true,
        default: () => ({}),
    },
})
const header = useTemplateRef('header')
const stuckDetector = useTemplateRef('stuck-detector')
const isOpen = ref(open)
const isStuck = ref(false)

const name = computed(() => slugify(config.label))
const hasImages = computed(() => name.value === 'finish' || config.options.some(option => option.attributes.image))

function handleSelect(option) {
    emit('select', option, config)
}

function toggle() {
    isOpen.value = !isOpen.value
    emit('update:open', isOpen.value)
}

const observer = new IntersectionObserver(([entry]) => {
    isStuck.value = entry.intersectionRatio < 1
}, { threshold: [1] })

onMounted(() => {
    observer.observe(stuckDetector.value);
})
onBeforeUnmount(() => {
    observer.unobserve(stuckDetector.value);
})
</script>
